import './Preferences.scss'
import React, { useState, useEffect } from 'react'
import translate from '../../../utilities/translate'
import translations from './translations'
import Form from '../../../widgets/Form'
import Checkbox from '../../../widgets/Form/Checkbox'
import Error from '../../../widgets/Form/Error'
import Toast from '../../Toastr/Toast'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  updateNewsletterSubscription,
  updatePartnerSubscription,
  locale,
  user,
  submitting,
  error,
  success,
}) => {
  const [ newsletterSubscription, setNewsletterSubscription ] = useState(false)
  const [ partnerSubscription, setPartnerSubscription ] = useState(false)

  useEffect(() => {
    if (null !== user) {
      setNewsletterSubscription(user.newsletterSubscription)
      setPartnerSubscription(user.partnerSubscription)
    } else {
      setNewsletterSubscription(false)
      setPartnerSubscription(false)
    }
  }, [ user ])

  return (
    <div className="preferences" >
      <h2>{trans(locale)('preferences')}</h2>
      <Form onSubmit={ () => {} } variant="horizontal">
        <div className="preferences-checkboxes">
          <div>
            <Checkbox
              name="newsletterSubscription"
              label={ trans(locale)('newsletterSubscription') }
              checked={ newsletterSubscription }
              onChange={ () => {
                updateNewsletterSubscription(!newsletterSubscription)
                setNewsletterSubscription(!newsletterSubscription)
              } }
              disabled={ submitting }
            />
          </div>
          <div>
            <Checkbox
              name="partnerSubscription"
              label={ trans(locale)('partnerSubscription') }
              checked={ partnerSubscription }
              onChange={ () => {
                updatePartnerSubscription(!partnerSubscription)
                setPartnerSubscription(!partnerSubscription)
              } }
              disabled={ submitting }
            />
          </div>
        </div>
      </Form>
      { error ? <Error>{ trans(locale)('error') }</Error> : null }
      { success ? <Toast message={ trans(locale)('success') } level="success" /> : null }
    </div>
  )
}
